/**
 * Bathymetry layer configuration.
 *
 * styleCode: the style value passed as the `style` query parameter to the DHI /maps API.
 * This is the StyleCode from the server's style.json "bathymetry" entry.
 */
export const BATHYMETRY_CONFIG = {
  itemNumber: 1,
  timeStep: '2000-01-01T12:00:00',
  styleCode: "-21:#008000|-19.5:#1A9A00|-18:#34B300|-16.5:#4DCD00|-15:#67E600|-13.5:#80FF00|-12:#9AFF00|-10.5:#B3FF00|-9:#CDFF00|-7.5:#E6FF00|-6:#FFFF00|-4.5:#EFD500|-3:#DFAB00|-1.5:#CF8100|0:#BF5700|1.5:#B02D00"
}

/**
 * Builds the POST body for the /maps API:
 * { datetime → relative dfsu file path }
 *
 * The path is relative to the server's App_Data folder.
 *
 * @param {string} modelId - The model ID (equals the MapOverlays subfolder name on the server)
 * @returns {{ [datetime: string]: string }}
 */
export const getBathymetryTimesteps = (modelId) => ({
  [BATHYMETRY_CONFIG.timeStep]: `\\applications\\Dilution\\WebAPI\\App_Data\\MapOverlays\\${modelId}\\Bathymetry.dfsu`,
})

